// extracted by mini-css-extract-plugin
export default {"inputHolder":"EditGuestDialog_inputHolder__alKKB","errorText":"EditGuestDialog_errorText__k9b0I"};